import {useEffect} from "react"
import {openTomBackoffice} from "./utils"
import {findNodeIdForElement} from "./node-registry"

export const useDevNodePicker = () => {
    useEffect(() => {
        if (window._env_?.MODE !== "dev") return

        const cursorStyle = document.createElement("style")
        cursorStyle.textContent =
            "*, *::before, *::after { cursor: help !important; }"
        let inspectCursorActive = false

        const enableInspectCursor = () => {
            if (inspectCursorActive) return
            inspectCursorActive = true
            document.head.appendChild(cursorStyle)
        }
        const disableInspectCursor = () => {
            if (!inspectCursorActive) return
            inspectCursorActive = false
            cursorStyle.remove()
        }

        const handleKeyDown = (event) => {
            if (event.altKey) {
                enableInspectCursor()
            }
        }
        const handleKeyUp = (event) => {
            if (event.key === "Alt" || !event.altKey) {
                disableInspectCursor()
            }
        }

        const handleClick = (event) => {
            if (!event.altKey) return

            const nodeId = findNodeIdForElement(event.target)
            if (!nodeId) return

            event.preventDefault()
            event.stopPropagation()
            disableInspectCursor()
            openTomBackoffice(nodeId)
        }

        document.addEventListener("click", handleClick, true)
        window.addEventListener("keydown", handleKeyDown)
        window.addEventListener("keyup", handleKeyUp)
        window.addEventListener("blur", disableInspectCursor)
        return () => {
            document.removeEventListener("click", handleClick, true)
            window.removeEventListener("keydown", handleKeyDown)
            window.removeEventListener("keyup", handleKeyUp)
            window.removeEventListener("blur", disableInspectCursor)
            disableInspectCursor()
        }
    }, [])
}

export default useDevNodePicker
